<template>
  <div class="hb-user-profile-edit-page">
    <div class="formss">

      <div style="margin: 10px 0">

        <el-button v-if="user_bind_info.bind_status == 1" type="primary" @click="showEmail">{{ user_bind_info.email }}</el-button>

        <el-button v-else type="danger" @click="bindEmail">绑定共享邮箱</el-button>
      </div>

      <!-- 邮箱绑定弹框 -->
      <el-dialog :visible.sync="openDialog" width="50%" center title="绑定邮箱">
        <div>
          <el-form ref="form" label-width="80px">
            <el-form-item label="邮箱" required>
              <el-input
                placeholder="请输入共享邮箱"
                v-model="emailCon.email"
                style="width: 60%"
              >
                <el-select
                  v-model="emailCon.email_value"
                  placeholder="请选择"
                  slot="append"
                  style="width: 130px"
                >
                  <el-option
                    v-for="(item, index) in email_list"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="邮箱密码" required>
              <el-input
                show-password
                v-model="emailCon.pass"
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" required>
              <el-input
                show-password
                v-model="emailCon.check_pass"
                placeholder="请再次输入密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" required>
              <el-input
                placeholder="请输入邮箱验证码"
                v-model="emailCon.email_code"
                style="width: 60%"
              ></el-input>
              <el-button
                style="margin: 0 20px; width: 20%"
                @click.stop="sendVerificationCode"
                type="primary"
                v-if="show"
                :loading="codeLoading"
              >发送验证码</el-button
              >
              <el-button
                style="margin: 0 20px; width: 20%"
                type="primary"
                v-if="!show"
                disabled
              >{{ count }}秒后重发</el-button
              >
              <!-- <div class="brief_introduction">
                推荐邮箱名格式：姓名拼音_出生年月日@163.com
                如：zhangsan_20200608@163.com
              </div> -->
            </el-form-item>
            <el-form-item label="授权码"  >
              <template slot="label">
                授权码
                <el-tooltip>
                  <div @click="checkEmpowerHelpe" slot="content">
                    查看填写说明？点我点我（老师可见）
                  </div>
                  <i class="el-icon-info" />
                </el-tooltip>
              </template>
              <el-input
                v-model="emailCon.email_empower"
                placeholder="请输入授权码"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="lookScores">保存</el-button>
      </span>
      </el-dialog>

      <!-- 邮箱详情弹框 -->
      <el-dialog :visible.sync="showDialog" width="50%" center title="共享邮箱">
        <div>
          <el-form ref="form">
            <el-form-item label="邮箱：">{{ user_bind_info.email }}</el-form-item>
            <el-form-item label="邮箱密码：">{{
                user_bind_info.email_pass
              }}</el-form-item>
            <el-form-item label="授权码：">{{ user_bind_info.email_empower }}</el-form-item>

          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">返 回</el-button>
        <el-button type="primary"  @click="confirmBindEmail">修 改</el-button>
      </span>
      </el-dialog>


      <h5 style="margin-top: 10px;font-weight: 700">时间规划  <el-button type="primary" size="mini" @click="addScheduleData">添加计划</el-button> </h5>

      <el-alert title="请老师和同学一起沟通，提前制定留学的时间规划" type="warning"> </el-alert>
      <div class="fifteen_content_body">
        <div class="title">
          <div>阶段/月份</div>
        </div>
        <div class="fifteen_content">
          <div style="display: flex">
            <div class="list" style="width: 8.33%" v-for="(item, index) in monthData" :key="index">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div class="fifteen_content_body" v-for="(list, index) in dayData" :key="index">
        <div class="title">
          <div class="list">
            <p>{{ list['grade_name'] }}</p>
            <p v-if="checkYear(list['grade_name'])" style="color: red">（今年）</p>
          </div>
        </div>
        <div class="fifteen_content" v-if="list['list'].length">
          <div v-for="(ite,inde) in list['list']" style="display: flex; ">
            <div class="list" :style="getWith(it)" v-for="(it,i) in ite">
              <img
                v-if="it.name && it.type==1"
                style="display: block;"
                class="add-lesson"
                src="../../../images/edit.png"
                @click="addSchedule(it)"
              />
              <el-tooltip class="item" v-if="it.name" effect="dark" :content="getModuleClassContent(it)" placement="top">
                <div class="moduleClass" :style="setBg(it.bg)">
                  <span v-if="it.type==1" style="color: red">(计划)</span> {{ it.name }}
                  <span v-if="it.title_name" >：{{it.title_name}}</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add_visa_process ref="addVisaProcess" @certain="getProjectProcess" />
  </div>
</template>
<script>
import {
  email_bind,
  email_code
} from "@/api/mycenter_studyabroad";
import add_visa_process from './addVisaProcess.vue'
import { get_project_planning_year, getProjectPlanningList } from '@/api/mycenter_studyabroad'
export default {
  name: 'TabFifteen',
  components: {
    add_visa_process
  },
  data() {
    return {
      user_bind_info: [],
      monthData: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      queryParam: {
        'user_id': this.$route.query.userId
      },
      codeLoading: false,
      show: true,
      count: "",
      timer: null,
      email_list: ["@163.com"],
      emailCon: {
        check_pass: "",
        email: "",
        pass: "",
        email_value: "@163.com",
        email_code: "",
        email_empower: ''
      },
      openDialog: false,
      showDialog: false,
      dayData: '', // 数据
      data: '' // 原数据
    }
  },
  created() {
    this.getProjectProcess()
    this.getUserBindInfo();

  },
  methods: {
    checkEmpowerHelpe() {
      window.open(
        "https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E823995081994177.pdf",
        "_blank"
      );
    },
    confirmBindEmail() {
      if(this.user_bind_info.email){
        this.emailCon.email = this.user_bind_info.email.replace(/@163\.com$/, '');
      }else {
        this.emailCon.email = this.user_bind_info.email
      }
      this.emailCon.check_pass = this.user_bind_info.email_pass
      this.emailCon.pass = this.user_bind_info.email_pass
      this.emailCon.email_code = ''
      this.emailCon.email_empower = this.user_bind_info.email_empower
      this.showDialog = false
      this.openDialog = true;
    },
    lookScores() {
      if (!this.emailCon.email) {
        this.$message({
          message: "邮箱不能为空",
          type: "error",
        });
        return;
      }
      if (!this.emailCon.email_code) {
        this.$message({
          message: "验证码不能为空",
          type: "error",
        });
        return;
      }
      if (!this.emailCon.pass) {
        this.$message({
          message: "密码输入不能为空",
          type: "error",
        });
        return;
      }
      if (!this.emailCon.email_empower) {
        this.$message({
          message: "授权码不能为空",
          type: "error",
        });
        return;
      }
      if (this.emailCon.pass !== this.emailCon.check_pass) {
        this.$message({
          message: "两次密码输入不一致",
          type: "error",
        });
        return;
      }
      email_bind({ email: this.emailCon, user_id: this.urserid }).then(
        (response) => {
          this.openDialog = false;
          this.getUserBindInfo();
        }
      );
    },
    getUserBindInfo() {
      this.$store
        .dispatch(
          "userAbroad/geUserAbroadData",
          parseInt(this.$route.query.userId)
        )
        .then(() => {
          this.user_bind_info = this.$store.state.userAbroad.userAbroadData;
        });
    },

    getModuleClassContent(it) {
      let str = it.name
      if (it.title_name) {
        str = str + '：' + it.title_name
      }
      return str
    },
    checkYear(_year){
      return _year == new Date().getFullYear()
    },
    setBg(_bg) {
      return 'background:' + _bg
    },


    timetable(_index, _inde, _i, _type) {
      // 课表hover移入移除
      if (_type == 1) {
        this.dayData[_index]['list'][_inde][_i].hover = false
      } else {
        this.dayData[_index]['list'][_inde][_i].hover = true
      }
      this.$forceUpdate()
    },
    addScheduleData() {
      // console.log('tianj', _grade_name,_month_number)
      // let month_name
      // this.monthData.forEach(function(item, index) {
      //   if (index == _month_number) {
      //     month_name = item
      //   }
      // })
      // this.$refs.addVisaProcess.sendItem([],_grade_name,month_name)
      this.$refs.addVisaProcess.sendItem()

    },
    addSchedule(_it) {
      let l = []
      if (_it) {
        this.data.forEach(function(element) {
          if (_it.id == element.id) {
            l = element
          }
        })
      }
      l.name_list = _it.name_list
      this.$refs.addVisaProcess.sendItem(l,null,null)
    },
    sendVerificationCode() {
      if (!this.emailCon.email) {
        this.$message({
          message: "邮箱不能为空",
          type: "error",
        });
        return;
      }
      this.email_code();
    },
    email_code() {
      this.codeLoading = true;
      var email = this.emailCon.email + this.emailCon.email_value;
      email_code({ email: email })
        .then((response) => {
          this.startCountDown();
          this.codeLoading = false;
          this.$message.success(
            `验证码已发送至：${this.emailCon.email}，请前往查收`
          );
        })
        .catch((error) => {
          this.$message.error(error.message);
          this.codeLoading = false;
        });
    },
    startCountDown() {
      var TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    bindEmail() {
      this.openDialog = true;
    },
    showEmail() {
      this.showDialog = true;
    },
    changeStyle() {
      return 'style="display: block;"'
    },
    resetStyle() {
      return 'style="display: none;"'
    },
    getWith(_num) {
      let str = 'width:' + _num.occupy_grid * 8.33 + '%'
      return str
    },
    getProjectPlanningYear() {
      get_project_planning_year(this.queryParam)
        .then((response) => {
          this.dayData = response.data.grade
        })
    },
    getProjectProcess() {
      getProjectPlanningList(this.queryParam)
        .then((response) => {
          this.data = response.data.data
          this.dayData = response.data.result_data
          this.dayData.map((list) => {
            list.list.map((im, index) => {
              im.map((item, i) => {
                if (item) {
                  item.hover = false
                }
              })
            })
          })
        })
        .catch((error) => {
          console.log(error)
          this.queryParam.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .fifteen_content_body {
    display: flex;
    align-items:center;
    flex-wrap: wrap;
    align-content: stretch;
    border: 1px solid #f1f1f1;
    border-top:none;
    box-sizing: border-box;
  }
  .title{
    text-align: center;
    width: 10%;
  }
  .moduleClass{
    padding: 0  5px;
    font-size: 0.7rem;
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
  }
  .fifteen_content{
    border-left: 1px solid #f1f1f1;
    width: 90%;
    .list{
      line-height: 3rem;
      //width: 8.333%;
      height: 3rem;
      user-select: none;
      position: relative;
      text-align: center;
      font-size: 1vw;
      cursor: pointer;
      border-right: 1px solid #f1f1f1;
      border-bottom: 1px solid #f1f1f1;
    }
  }
  .list .add-lesson {
    width: 20px;
    heihgt: 20px;
    position: absolute;
    top: 0;
    right: 0;
    display: none;
  }
  .formss {
    .week {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      //  flex-wrap: wrap;
      border-bottom: 1px solid #d1d1d1;
      justify-content: space-between;
    }
    .timetable {
      width: 100%;
      display: flex;
      justify-content: space-between;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_fifteen.vue